import {
  PromoFormValues,
  Promo,
  PromoFromAPI,
  Days,
  PromoConditions,
} from 'types/promotion/promotionTypes';
import { formatToYMD } from 'utils/common/Time';

// export const mapPromoFormValuesToPromo = async (
export const mapPromoFormValuesToPromo = async (
  data: PromoFormValues
): Promise<Promo> => {
  return {
    store_ids: data.branch,
    name: data.promoName,
    promotion_type: parseInt(data.promoType, 10),
    type_discount: parseInt(data.DiscountType, 10),
    type_conditions: parseInt(data.ConditionType, 10),
    not_limit_date: parseInt(data.notLimitDate, 10),
    start_date: data.promoPeriod.dateRange.start
      ? formatToYMD(data.promoPeriod.dateRange.start)
      : '',
    end_date: data.promoPeriod.dateRange.end
      ? formatToYMD(data.promoPeriod.dateRange.end)
      : '',

    time_start: data.promoPeriod?.timeRange?.start || '',
    time_end: data.promoPeriod?.timeRange?.end || '',
    days: convertDaysForAPI(data.promoPeriod?.days || []),
    promotion_conditions: data.promoProducts?.lists || [],
    promotion_discount:
      data.promoType !== '4'
        ? convertPromoDiscountForAPI(data.promoDiscount)
        : [],
    promotion_free_items:
      data.promoType === '4'
        ? {
            condition_type: Number(data.promoFreeGift.conditionType),
            threshold_value: Number(data.promoFreeGift.thresholdValue),
            free_type: Number(data.promoFreeGift.freeType),
            free_list: data.promoFreeGift.freeList,
            free_qty: Number(data.promoFreeGift.freeQty),
          }
        : null,
    usage_limit: parseInt(data.usage_limit, 10),
    // start_date: formatToYMD(data.promoPeriod.dateRange.start),
    // end_date: formatToYMD(data.promoPeriod.dateRange.end),
    // time_start: data.promoPeriod.timeRange.start,
    // time_end: data.promoPeriod.timeRange.end,
    // days: convertDaysForAPI(data.promoPeriod.days),
    // promotion_conditions: data.promoProducts.lists,
    // promotion_discount: convertPromoDiscountForAPI(data.promoDiscount),

    active: parseInt(data.isActive, 10),
  };
};

// export const mapPromoAPIToPromoForm = async (
export const mapPromoAPIToPromoForm = async (
  data: PromoFromAPI
): Promise<PromoFormValues> => {
  // Adjust date by -7 hours and format in ISO 8601
  const startDate = new Date(
    new Date(data.start_date).getTime() - 7 * 60 * 60 * 1000
  );
  const endDate = new Date(
    new Date(data.end_date).getTime() - 7 * 60 * 60 * 1000
  );
  const is_period = data.not_limit_date === 0 ? 1 : 0;

  const days = {
    sun: false,
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false,
  };

  for (const day of data.days) {
    switch (day.toLowerCase()) {
      case 'sunday':
        days.sun = is_period === 1 ? true : false;
        break;
      case 'monday':
        days.mon = is_period === 1 ? true : false;
        break;
      case 'tuesday':
        days.tue = is_period === 1 ? true : false;
        break;
      case 'wednesday':
        days.wed = is_period === 1 ? true : false;
        break;
      case 'thursday':
        days.thu = is_period === 1 ? true : false;
        break;
      case 'friday':
        days.fri = is_period === 1 ? true : false;
        break;
      case 'saturday':
        days.sat = is_period === 1 ? true : false;
        break;
    }
  }

  const promoFree = data.promotion_free_items;

  // const freeList =
  //   data.promotion_type === 4
  //     ? data.promotion_free_items.free_items.map((item) => ({
  //         name: item.name,
  //         code: item.code,
  //         qty: item.qty.toString(),
  //       }))
  //     : [];

  const freeList =
    data.promotion_type === 4 &&
    data.promotion_free_items &&
    Array.isArray(data.promotion_free_items.free_list)
      ? data.promotion_free_items.free_list.map((item) => item.code)
      : [];

  return {
    promoName: data.name,
    branch: data.store_ids,
    promoType: String(data.promotion_type),
    notLimitDate: String(data.not_limit_date),
    DiscountType: data.type_discount.toString(),
    ConditionType: data.type_conditions.toString(),
    promoPeriod: {
      dateRange: {
        start:
          is_period === 1
            ? startDate.toISOString().split('.')[0] + '.000Z'
            : '',
        end:
          is_period === 1 ? endDate.toISOString().split('.')[0] + '.000Z' : '',
      },
      timeRange: {
        start: is_period === 1 ? data.time_start : '',
        end: is_period === 1 ? data.time_end : '',
      },
      days: days,
    },
    promoProducts: {
      lists: convertPromoConditions(data.promotion_conditions),
      info: data.promotion_conditions,
    },
    promoDiscount:
      data.promotion_type === 4
        ? [
            {
              qty: '',
              discount: '',
            },
          ]
        : convertPromoDiscountToStr(data.promotion_discount),
    // promoFreeGift: {
    //   conditionType: data.promotion_free_items.condition_type.toString(),
    //   thresholdValue: data.promotion_free_items.threshold_value.toString(),
    //   freeType: data.promotion_free_items.free_type.toString(),
    //   freeQty: data.promotion_free_items.free_qty.toString(),
    //   freeList: promoFreeGift,
    // },
    promoFreeGift: promoFree
      ? {
          conditionType: promoFree.condition_type?.toString() || '1',
          thresholdValue: promoFree.threshold_value?.toString() || '',
          freeType: promoFree.free_type?.toString() || '',
          freeQty: promoFree.free_qty?.toString() || '',
          freeList: freeList,
        }
      : {
          conditionType: '1',
          thresholdValue: '',
          freeType: '',
          freeQty: '',
          freeList: [],
        },
    usage_limit: data.usage_limit ? data.usage_limit.toString() : '0',
    isActive: String(data.active),
  };
};

function convertDaysForAPI(days: Days): string[] {
  const dayMapping: { [key: string]: string } = {
    sun: 'sunday',
    mon: 'monday',
    tue: 'tuesday',
    wed: 'wednesday',
    thu: 'thursday',
    fri: 'friday',
    sat: 'saturday',
  };

  const inputDays: string[] = [];

  for (const [key, value] of Object.entries(days)) {
    if (value) {
      inputDays.push(dayMapping[key]);
    }
  }

  return inputDays;
}

function convertPromoDiscountForAPI(
  data: { discount: string; qty: string }[]
): { discount: number; qty: number }[] {
  return data.map((item) => ({
    discount: parseFloat(
      parseFloat(item.discount.replace(/,/g, '')).toFixed(2)
    ),
    qty: parseFloat(parseFloat(item.qty.replace(/,/g, '')).toFixed(2)),
  }));
}

function convertPromoDiscountToStr(
  data: { discount: number; qty: number }[]
): { discount: string; qty: string }[] {
  if (data.length === 0)
    return [
      {
        qty: '',
        discount: '',
      },
    ];
  return data.map((item) => ({
    discount: item.discount.toString(),
    qty: item.qty.toString(),
  }));
}
function convertPromoConditions(data: PromoConditions[]): string[] {
  const lists: string[] = [];
  data.forEach((item) => {
    lists.push(item.code);
  });
  return lists;
}
